class UnauthorizedError extends Error {
  constructor (message) {
    super(message)

    this.name = 'UnauthorizedError'
  }
}

export default UnauthorizedError
